/**
 * Created by andreyna on 6/1/2016.
 */
import BaseModelService from '../../base/base_model_service';
import _ from '../../utils/underscore';

const GNWP_URL_DEFAULT = '/cgpapi/gnwp/getGnwpConfig';

/**
 *
 *
 */
class GNWPServiceModel extends BaseModelService {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'GNWPServiceModel';

    private _apiURI: string;
    private _navigationURI: string;
    private _templates: string[];


    /**
     *
     * @param params
     */
    init(params) {
        if (params) {
            this
                ._setTemplates(params.templates)
                ._setURI(params.uri)
                ._setNavigationURI(params.sharedNavigationURI);
        }
    }


    /**
     * Set API URI that handle GNWP request
     *
     * @param apiUri
     * @returns {GNWPServiceModel}
     * @private
     */
    _setURI(apiUri) {
        if (!_.isString(apiUri)) {
            this._apiURI = GNWP_URL_DEFAULT;
            return this;
        }

        this._apiURI = apiUri;
        return this;
    }

    /**
     * Set list of existed GNWP templates from configuration for further validation before request
     *
     * @param templates
     * @returns {GNWPServiceModel}
     * @private
     */
    _setTemplates(templates: string) {
        let isValid = false;
        if (_.isString(templates)) {
            try {
                this._templates = JSON.parse(templates);
                isValid = true;
            } catch(e) {
            }
        }

        if (!isValid) {
            this.logger.error(GNWPServiceModel.CLASS + "--> template list is not defined correctly.");
        }

        return this;
    }


    /**
     * Set GNWP navigation URI. URI is aspx third party page used as proxy service for redirection to specified web site (service)
     *
     * @param uri
     * @returns {GNWPServiceModel}
     * @private
     */
    _setNavigationURI(uri) {
        if (!_.isString(uri)) {
            return this;
        }

        this._navigationURI = uri;
        return this;
    }


    /**
     * Get API GNWP request URI
     *
     * @returns {string}
     * @public
     */
    getGNWPUri() {
        return this._apiURI;
    }


    /**
     * Get GNWP navigation URI
     *
     * @returns {string}
     */
    getRedirectUri() {
        return this._navigationURI;
    }

    /**
     * Validate if template exists in list of allowed templates
     *
     * @param {string} template
     * @returns {boolean}
     */
    isValidTemplate(template: string) {
        const isValid = this._templates.find(t => {
            return t === template;
        });

        return isValid ? true : false;
    }
}

export default GNWPServiceModel;
